<template>
  <div class="block-image">
    <van-image v-if="lazy" :src="src" lazy-load />
    <van-image v-else-if="van" :src="src" />
    <img v-else :src="src" />
    <div v-if="mask || safe" class="mask" :class="{ dimMask: mask }"></div>
  </div>
</template>

<script>
export default {
  name: "sd-img",
  props: {
    src: String,
    mask: Boolean,
    lazy: Boolean,
    safe: Boolean,
    van: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.block-image {
  width: 100%;
  height: 100%;
  position: relative;

  .mask {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    &.dimMask {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/image.vue